var en_us = {
    values: {
        SISP: 'SIP',
        URL: 'URL',
        'BOP Test Id on SIP': 'BOP Test Id on SIP',
        'API Token': 'API Token',
        'Session token': 'Session token',
        'Send to': 'Send to',
        'Choose the well related with the test': 'Choose the well related with the test',
        'Choose the SIP type test': 'Choose the SIP type test',
        'Error loading well list': 'Error loading well list',
        'Loading wells': 'Loading wells',
        Send: 'Send',
        'Intervention name': 'Intervention name',
        'Test successfully sent': 'Test successfully sent',
        'Test sent': 'Test sent',
        'There was a problem sending the data': 'There was a problem sending the data',
        'Try again': 'Try again',
        Message: 'Message',
        Loading: 'Loading',
        'SIP Types': 'SIP Types',
        Auth: 'Authentication',
        User: 'User',
        Password: 'Password',
        'Client ID': 'Client ID',
        Connection: 'Connection',
        'SIP Configuration': 'SIP Configuration'
    }
}

module.exports = en_us
